import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";

export class LoadingStore {
    showLoader: boolean = false;

    rootStore: IRootStore;

    constructor(rootStore: IRootStore) { 
        makeAutoObservable(this);

        this.rootStore = rootStore;
    }

    setShowLoader = (isLoaderShow: boolean) => {
        this.showLoader = isLoaderShow;
    }

    get getShowLoader() {
        return this.showLoader;
    }
}